module.exports = __webpack_public_path__ + "img/toolsItem06.f5c48118.png";